/** The addresses of the Foundry import's pages (2.I-2 provides; 2.Q s5's journeys link to them). */
import { foundryMacroGet } from '@codex/contracts';
import { characterSheetHref } from '../sheets/pc/href.js';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** A search value kept only when it is a uuid; anything else is dropped without throwing. */
export function uuidOrUndefined(value: unknown): string | undefined {
  return typeof value === 'string' && UUID.test(value) ? value : undefined;
}

/** `/foundry`, with `sheet` for a refresh started from a page's pill (stage s2). */
export function foundryHref(options: { sheet?: string } = {}): string {
  return options.sheet ? `/foundry?sheet=${encodeURIComponent(options.sheet)}` : '/foundry';
}

/** `/foundry/imports/$importId`, with `targetSheetId` for the sheet a review is against. */
export function importDetailHref(
  importId: string,
  options: { targetSheetId?: string } = {},
): string {
  const base = `/foundry/imports/${encodeURIComponent(importId)}`;
  return options.targetSheetId
    ? `${base}?targetSheetId=${encodeURIComponent(options.targetSheetId)}`
    : base;
}

/** A page of the campaign (`/doc/$id`). */
export const docPageHref = (docId: string): string => `/doc/${encodeURIComponent(docId)}`;

/** `/foundry/history`: Import history (stage s2). */
export const historyHref = (): string => '/foundry/history';

/** The Codex macro's download: `foundry.macro.get`'s contract path. */
export const macroHref = (): string => foundryMacroGet.path;

/** A PC's character sheet: 2.H's `characterSheetHref` (`/sheets/pc/<docId>?sheet=<sheetId>`). */
export function pcSheetHref(docId: string, sheetId?: string | null): string {
  return characterSheetHref(docId, sheetId ? { sheetId } : {});
}
